/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getEarningStreamsSummary} from '../api'

 export const useQueryGetEarningStreamsSummary = createReactQueryHook('getEarningStreamsSummary', getEarningStreamsSummary)
